<div class="mt-4 grid grid-cols-12 gap-x-1.5">
  <div class="col-span-4 border bg-white">
    <div class="grid grid-cols-3 p-4 pr-3">
      <div class="col-span-2 p-2 font-bold">Vendor Contracts</div>
      <div class="p-2 text-center font-bold">Period Discount</div>
      <hr class="col-span-full" />

      @for (v of vendors$ | async; track v) {
        <div class="col-span-2 p-2">{{ v.name }}</div>
        @if (v.discount_value !== null) {
          <div class="p-2 text-right">
            {{ v.discount_value | money: v.currency }}
          </div>
        }
        @if (v.discount_value === null) {
          <div class="p-2 text-right">
            <button class="btn--hyperlink px-0 font-normal" (click)="selectVendor(v.vendor_id)">
              Calculate
            </button>
          </div>
        }

        <hr class="col-span-full" />
      }
    </div>
  </div>

  <div class="col-span-8 border bg-white">
    <div class="p-6">
      <div class="mb-4 font-bold">1. Select Vendor Contract</div>

      <div class="flex space-x-7">
        <div>
          <div class="mb-2 text-xs">
            Vendor Contract
            <span class="font-bold text-aux-error">*</span>
          </div>
          <ng-select
            placeholder="Select"
            id="vendors"
            class="w-36"
            [formControl]="selectedVendor"
            [appendTo]="'body'"
            [searchable]="true"
            [clearable]="false"
            (change)="onVendorSelected()"
          >
            @for (vendor of vendors$ | async; track vendor) {
              <ng-option [value]="vendor.vendor_id">
                <span [title]="vendor.name">{{ vendor.name }}</span>
              </ng-option>
            }
          </ng-select>
        </div>
        <div>
          <div class="mb-2">Eligible Service Costs</div>
          <div class="text-xl">{{ serviceCost | money: selectedCurrency }}</div>
        </div>
        <!--        <div class="border-r"></div>-->
        <!--        <div>-->
        <!--          <div class="mb-2"># Manual Adjustments</div>-->
        <!--          <div class="text-xl">5</div>-->
        <!--        </div>-->
      </div>
    </div>
    <div class="px-6"><hr /></div>
    <div class="p-6">
      <div class="mb-4 font-bold">2. Calculate Discount</div>

      <div class="flex space-x-7">
        <div>
          <div class="flex flex-1 items-center">
            <input
              id="discount-contracted"
              name="discount-calc"
              type="radio"
              value="contracted"
              class="h-4 w-4 border-gray-300 text-indigo-600 focus:ring-indigo-500"
              [disabled]="!contractedPercentage || isDiscountWorkflowLocked()"
              [auxTooltip]="discountLockTooltip()"
              [(ngModel)]="discountCalc"
              (ngModelChange)="onChange()"
              (click)="clearIfNecessary('calc', 'contracted')"
            />
            <label for="discount-contracted" class="ml-3">
              <span class="block text-sm font-medium text-gray-700">Contracted Discount %</span>
            </label>
          </div>
          <div class="ml-6 mt-1 flex h-10 items-center pl-1 text-xl">
            {{ contractedPercentageStr }}
          </div>
        </div>

        <div>
          <div class="flex flex-1 items-center">
            <input
              id="discount-custom"
              name="discount-calc"
              type="radio"
              value="custom"
              class="h-4 w-4 border-gray-300 text-indigo-600 focus:ring-indigo-500"
              [(ngModel)]="discountCalc"
              (ngModelChange)="onChange()"
              (click)="clearIfNecessary('calc', 'custom')"
              [disabled]="isDiscountWorkflowLocked()"
              [auxTooltip]="discountLockTooltip()"
            />
            <label for="discount-custom" class="ml-3">
              <span class="block text-sm font-medium text-gray-700">Custom %</span>
            </label>
          </div>
          <input
            type="text"
            class="input h-10 w-24"
            [(ngModel)]="customPercentage"
            (ngModelChange)="onChange()"
            [disabled]="isDiscountWorkflowLocked()"
            [auxTooltip]="discountLockTooltip()"
          />
        </div>

        <div class="flex items-end">
          <aux-button
            variant="primary"
            label="Calculate"
            icon="Plus"
            [disabled]="
              !selectedVendor.value ||
              !discountCalc ||
              (discountCalc === 'custom' && !customPercentage) ||
              isDiscountWorkflowLocked()
            "
            [onClick]="onCalculate.bind(this)"
            [auxTooltip]="discountLockTooltip()"
          />
        </div>

        <div class="border-r"></div>

        <div>
          <div class="mb-2">Calculated Discount</div>
          <div class="text-xl">{{ calculatedAmount | money: selectedCurrency }}</div>
        </div>
      </div>
    </div>
    <div class="px-6"><hr /></div>
    <div class="p-6">
      <div class="mb-4 font-bold">3. Select Discount for Period Close</div>

      <div class="flex space-x-7">
        <div>
          <div class="flex flex-1 items-center">
            <input
              id="discount-selection-calc"
              name="discount-selection"
              type="radio"
              value="calculated"
              class="h-4 w-4 border-gray-300 text-indigo-600 focus:ring-indigo-500"
              [disabled]="isCalculatedSelectionDisabled || isDiscountWorkflowLocked()"
              [auxTooltip]="discountLockTooltip()"
              [(ngModel)]="selectedDiscountType"
              (ngModelChange)="onChange()"
              (click)="clearIfNecessary('selection', 'calculated')"
            />
            <label for="discount-selection-calc" class="ml-3">
              <span class="block text-sm font-medium text-gray-700">Calculated Discount</span>
            </label>
          </div>
          <div class="ml-6 mt-1 flex h-10 items-center pl-1 text-xl">
            {{ calculatedAmount | money: selectedCurrency }}
          </div>
        </div>

        <div>
          <div class="flex flex-1 items-center">
            <input
              id="discount-selection-vendor"
              name="discount-selection"
              type="radio"
              value="vendor"
              class="h-4 w-4 border-gray-300 text-indigo-600 focus:ring-indigo-500"
              [disabled]="vendorEstDiscount === null || isDiscountWorkflowLocked()"
              [auxTooltip]="discountLockTooltip()"
              [(ngModel)]="selectedDiscountType"
              (ngModelChange)="onChange()"
              (click)="clearIfNecessary('selection', 'vendor')"
            />
            <label for="discount-selection-vendor" class="ml-3">
              <span class="block text-sm font-medium text-gray-700">Vendor Est. Discount</span>
            </label>
          </div>
          <div class="ml-6 mt-1 flex h-10 items-center pl-1 text-xl">
            @if ((loading$ | async) === true) {
              <span class="spinner h-5 w-5"></span>
            }
            @if ((loading$ | async) === false) {
              {{ vendorEstDiscount | money: selectedCurrency }}
            }
          </div>
        </div>
        <div>
          <div class="flex flex-1 items-center">
            <input
              id="discount-selection-invoice"
              name="discount-selection"
              type="radio"
              value="invoice"
              class="h-4 w-4 border-gray-300 text-indigo-600 focus:ring-indigo-500"
              [disabled]="invoiceDiscount === null || isDiscountWorkflowLocked()"
              [auxTooltip]="discountLockTooltip()"
              [(ngModel)]="selectedDiscountType"
              (ngModelChange)="onChange()"
              (click)="clearIfNecessary('selection', 'invoice')"
            />
            <label for="discount-selection-invoice" class="ml-3">
              <span class="block text-sm font-medium text-gray-700">Invoice Discount</span>
            </label>
          </div>
          <div class="ml-6 mt-1 flex h-10 items-center pl-1 text-xl">
            @if ((loading$ | async) === true) {
              <span class="spinner h-5 w-5"></span>
            }
            @if ((loading$ | async) === false) {
              {{ invoiceDiscount | money: selectedCurrency }}
            }
          </div>
        </div>

        <div>
          <div class="flex flex-1 items-center">
            <input
              id="discount-selection-custom"
              name="discount-selection"
              type="radio"
              value="custom"
              class="h-4 w-4 border-gray-300 text-indigo-600 focus:ring-indigo-500"
              [(ngModel)]="selectedDiscountType"
              (ngModelChange)="onChange()"
              (click)="clearIfNecessary('selection', 'custom')"
              [auxTooltip]="discountLockTooltip()"
              [disabled]="isDiscountWorkflowLocked()"
            />
            <label for="discount-selection-custom" class="ml-3">
              <span class="block text-sm font-medium text-gray-700">
                Custom ({{ getCurrencySymbol(selectedCurrency) }})
              </span>
            </label>
          </div>
          <input
            type="text"
            class="input h-10 w-40"
            [(ngModel)]="customAmount"
            (ngModelChange)="onChange()"
            [auxTooltip]="discountLockTooltip()"
            [disabled]="isDiscountWorkflowLocked()"
          />
        </div>

        <div>
          <div class="flex flex-1 items-center">
            <input
              id="discount-selection-none"
              name="discount-selection"
              type="radio"
              value="none"
              class="h-4 w-4 border-gray-300 text-indigo-600 focus:ring-indigo-500"
              [(ngModel)]="selectedDiscountType"
              (click)="clearIfNecessary('selection', 'none')"
              (ngModelChange)="onChange()"
              [auxTooltip]="discountLockTooltip()"
              [disabled]="isDiscountWorkflowLocked()"
            />
            <label for="discount-selection-none" class="ml-3">
              <span class="block text-sm font-medium text-gray-700">No Discount</span>
            </label>
          </div>
        </div>

        <div>
          <aux-button
            label="Save"
            variant="success"
            classList="ml-1"
            [onClick]="onSave.bind(this)"
            [disabled]="(saveButtonDisabled$ | async) === true || isDiscountWorkflowLocked()"
            [auxTooltip]="discountLockTooltip()"
            icon="Check"
            [loading]="saveLoading$ | async"
          />
        </div>
      </div>
    </div>
  </div>
</div>
